<script setup lang="ts">
import { ref } from 'vue';
import Button from 'primevue/button';

const { title, description, toggled } = defineProps(['title', 'description', 'toggled']);

const state = ref(toggled);

const emit = defineEmits<{
  (e: 'click', toggled: boolean): void;
}>();

function onClick() {
  state.value = !state.value;
  emit('click', state.value);
}
</script>

<template>
  <Button severity="secondary" class="toggle-item" @click="onClick()">
    <div class="icon"><slot name="icon"></slot></div>
    <strong class="title">{{ title }}</strong>
    <span class="description">{{ description }}</span>
  </Button>
</template>

<style scoped>
.toggle-item {
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-columns: auto auto;
  justify-content: start;
}

.icon {
  grid-row: 1/3;
  grid-column: 1;
  align-self: center;
}

.title {
  grid-row: 1;
  grid-column: 2;
  font-weight: 400;
  justify-self: start;
}

.description {
  grid-row: 2;
  grid-column: 2;
  justify-self: start;
}
</style>
